import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { getIsActiveFollowRoute } from '../../../helpers/common'
import { CustomLink } from '../../CustomLink'
import { Dropdown, positionDropdown } from '../../dropdown'
import { DropdownList } from '../../dropdown/DropdownList'
import { HandleClickOutside } from '../../HandleClickOutside'
import { UseTypeFontSize } from '../../hooks/useTypeFontSize'
import { Element } from '../../html/element'
import { Icon } from '../../html/icon'
import { LockAction } from '../../LockAction'
import { Label } from '../Label'
import classes from './index.module.scss'

export const Item = ({
  label,
  isI18n,
  isLock,
  keepQueryStrParams,
  children,
  route,
  setWidths,
  isBorderLeft,
}) => {
  const ref = useRef()
  const location = useLocation()

  const isActive = getIsActiveFollowRoute(location, route, children)
  const typeFontSize = UseTypeFontSize()
  const locale = useSelector((state) => state.i18n.locale)

  const [isShow, setIsShow] = useState()

  useEffect(() => {
    if (ref.current && setWidths) {
      setWidths((widths) => ({
        ...widths,
        [label]: ref.current.getBoundingClientRect().width,
      }))
    }
  }, [ref.current, typeFontSize, locale])

  const onClick = () => {
    if (children) {
      setIsShow(!isShow)
    }
  }

  return (
    <Element
      ref={ref}
      elementName="li"
      onClick={onClick}
      style={{
        backgroundColor: isActive ? '#ECF3FF' : '#EBEBEB',
        borderLeftColor: isBorderLeft && '#FFFFFF',
        borderLeftWidth: isBorderLeft && 1,
        borderLeftStyle: isBorderLeft && 'solid',
        position: 'relative',
        cursor: !isLock && 'pointer',
      }}
    >
      <CustomLink
        to={route}
        inActive={isLock}
        keepQueryStrParams={keepQueryStrParams}
      >
        <LockAction enable={isLock}>
          <div className={classes.item}>
            <Label label={label} isActive={isActive} isI18n={isI18n} />
            {isLock && (
              <Icon
                className="icon-lock"
                style={{ color: '#9C9C9C', fontSize: 10, marginLeft: 5 }}
              />
            )}
            {children && (
              <Icon
                className="icon-caret-bottom"
                style={{ color: '#3A414B', fontSize: 8, marginLeft: 5 }}
              />
            )}
          </div>
        </LockAction>
      </CustomLink>

      {children && isShow && (
        <Dropdown
          parentRef={ref}
          position={positionDropdown.BOTTOM_START_RIGHT}
        >
          <HandleClickOutside
            exceptRef={ref}
            handleClickOutside={() => {
              setIsShow(false)
            }}
          >
            <DropdownList
              data={children.map((item) => {
                return {
                  ...item,
                  isActive: getIsActiveFollowRoute(location, item.route),
                  isI18n: true,
                }
              })}
              onClickItem={() => setIsShow(false)}
            />
          </HandleClickOutside>
        </Dropdown>
      )}
      {isActive && (
        <Element
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            height: 4,
            backgroundColor: '#2C73E8',
          }}
        />
      )}
    </Element>
  )
}

Item.propTypes = {
  label: PropTypes.string.isRequired,
  isI18n: PropTypes.bool,
  isLock: PropTypes.bool,
  route: PropTypes.string,
  children: PropTypes.array,
  setWidths: PropTypes.func,
}

Item.defaultProps = {
  isI18n: true,
  isLock: false,
  setWidths: () => {},
}
